import {
  DTSequenceNode,
  SequenceNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {OutputType} from 'common/src/modules/nodes/nodes.types';
import {getBaseHeader, getDestinationPhrase, getOutputIdentifier} from './utils';

function getTimeLabel(count: number): string {
  return count === 1 ? 'Time' : 'Times';
}

function getSequenceOutputSuffix(output: SequenceNodeOutputData): string {
  switch (output.type) {
    case OutputType.Last:
      return 'Choose Last for user';
    case OutputType.Fallback:
      return 'When user not identified';
    case OutputType.Regular:
    case OutputType.PartialSuccess:

    default: {
      const count = output.maxRepeats ?? 0;
      const label = getTimeLabel(count);

      return `Choose ${count} ${label} for user`;
    }
  }
}

export function sequenceCardToText(card: DTSequenceNode, mode: 'short' | 'full'): string {
  const header = getBaseHeader(card);

  if (mode === 'short') {
    const outputLines = card.outputs.map((output: SequenceNodeOutputData) => {
      const outputId = getOutputIdentifier(output);
      const maxRepeats = output.maxRepeats ?? 0;

      return `Output ${outputId} - Repetitions: ${maxRepeats}`;
    });

    return [header, ...outputLines].join('\n');
  }

  const hasLastOutput = card.outputs.some((output) => output.type === OutputType.Last);
  const cycleCount = card.maxRepeats ?? 0;
  const cycleTimeLabel = cycleCount === 1 ? 'time' : 'times';
  const cycleLine =
    hasLastOutput && card.maxRepeats != null && card.maxRepeats > 0
      ? `Repeat cycle ${cycleCount} ${cycleTimeLabel}`
      : 'Repeat cycle without end';

  const outputLines = card.outputs.map((output: SequenceNodeOutputData) => {
    const outputId = getOutputIdentifier(output);
    const dest = getDestinationPhrase(output.nodeId);
    const suffix = getSequenceOutputSuffix(output);

    return `Output ${outputId} ${dest} - ${suffix}`;
  });

  return [header, cycleLine, ...outputLines].join('\n');
}
